import { render } from "./HeaderContent.vue?vue&type=template&id=45aeea6d&lang=pug"
import script from "./HeaderContent.vue?vue&type=script&lang=js"
export * from "./HeaderContent.vue?vue&type=script&lang=js"

import "./HeaderContent.vue?vue&type=style&index=0&id=45aeea6d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__